var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var SvgLikeStroke = function SvgLikeStroke(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.191 30.4C9.691 23.373.8 18.762.8 10.54.8 5.138 3.811 1.6 8.639 1.6c3.776 0 7.552 2.916 7.552 8.366 0-5.45 3.346-8.366 7.744-8.366 4.588 0 7.265 3.968 7.265 9.035 0 8.749-8.508 12.738-15.009 19.765Z",
    stroke: "#000",
    strokeWidth: 1.2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
};

export default SvgLikeStroke;